import { Component, inject } from '@angular/core';
import { LoaderService, POPOVER_DATA, PopoverActionType, PopoverComponent, PopoverReference } from '@h5s/design-system';
import { timer } from 'rxjs';
import { UpdateNotificationPopoverParams } from './models/update-notification-popover-params';
import { FEATURE_UPDATE_NOTIFICATION_TRANSLATIONS } from './translations/feature-update-notification.translations';
import { FeatureUpdateNotificationService } from '../feature-update-notification.service';

/** ID del pulsante di ricarica utilizzato nel popover di notifica. */
export const reloadButtonId = 'reloadNow';

@Component({
  selector: 'h5s-feature-update-notification',
  imports: [],
  templateUrl: './feature-update-notification.component.html',
  styleUrl: './feature-update-notification.component.scss',
})
export class FeatureUpdateNotificationComponent implements PopoverComponent {
  private readonly popoverRef = inject(PopoverReference);
  private readonly loaderService = inject(LoaderService);
  private readonly popoverData = inject<UpdateNotificationPopoverParams>(POPOVER_DATA);
  private readonly featureUpdateNotificationService = inject(FeatureUpdateNotificationService);

  protected readonly translation = FEATURE_UPDATE_NOTIFICATION_TRANSLATIONS;

  protected readonly newVersion = this.popoverData.newVersion;

  public onPopoverAction(actionType: PopoverActionType): void {
    if (actionType === PopoverActionType.Cancel) {
      this.popoverRef.close({
        actionType,
      });
      return;
    }

    this.loaderService.showLoadingButton({
      buttonId: reloadButtonId,
      subscription: timer(2000).subscribe(() => {
        this.featureUpdateNotificationService.updateApp();
      }),
      delay: 0,
    });
  }
}
